import { ANIMAL_STATUS_LABELS, formatDate } from "../../lib/format";

type Props = {
  leftOn: string | null | undefined;
  status?: string | null;
  /** Dodatkowe zdanie w podpowiedzi (np. konsekwencje dla wykotu). */
  extra?: string;
};

export function departureMessage(
  leftOn: string,
  status?: string | null,
  extra?: string,
): string {
  const statusLabel = status ? ANIMAL_STATUS_LABELS[status]?.toLowerCase() : null;
  const base = `Zwierzę zniknęło ze stada dnia ${formatDate(leftOn)}${
    statusLabel ? ` (${statusLabel})` : ""
  }.`;
  return extra ? `${base} ${extra}` : base;
}

/** Informacyjny trójkąt: zwierzę opuściło stado (padło, sprzedane, ubite). */
export function HerdDepartureBadge({ leftOn, status, extra }: Props) {
  if (!leftOn) {
    return null;
  }
  const message = departureMessage(leftOn, status, extra);
  return (
    <span
      className="herd-departure-badge"
      role="img"
      aria-label={message}
      title={message}
      data-testid="herd-departure-badge"
    >
      <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false">
        <path d="M12 2.5 22.5 20.5h-21L12 2.5Z" fill="#f5b301" stroke="#9a6b00" strokeWidth="1.4" strokeLinejoin="round" />
        <rect x="11" y="9" width="2" height="6" rx="1" fill="#3b2a00" />
        <circle cx="12" cy="17.5" r="1.1" fill="#3b2a00" />
      </svg>
    </span>
  );
}
